const defaultOptions: { [key: string]: HvcWidgetOptions } = {
  'container-locations': {
    element: '#widgets-root',
    widgetId: 'container-locations',
    mapboxAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
    opzetApiUrl: 'https://inzamelkalender-test.hvcgroep.nl',
    websiteUrl: 'https://staging.hvcgroep.nl',
    apiUrl: 'https://staging.app.hvcgroep.nl',
    env: 'development',
  },
  'waste-calendar': {
    element: '#widgets-root',
    widgetId: 'waste-calendar',
    opzetApiUrl: 'https://inzamelkalender-test.hvcgroep.nl',
    websiteUrl: 'https://staging.hvcgroep.nl',
    apiUrl: 'https://staging.app.hvcgroep.nl',
    env: 'development',
  },
  reports: {
    element: '#widgets-root',
    widgetId: 'reports',
    opzetApiUrl: 'https://inzamelkalender-test.hvcgroep.nl',
    websiteUrl: 'https://staging.hvcgroep.nl',
    apiUrl: 'https://staging.app.hvcgroep.nl',
    env: 'development',
    mapboxAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  },
  measurements: {
    element: '#widgets-root',
    widgetId: 'measurements',
    opzetApiUrl: 'https://inzamelkalender-test.hvcgroep.nl',
    websiteUrl: 'https://staging.hvcgroep.nl',
    apiUrl: 'https://staging.app.hvcgroep.nl',
    env: 'development',
  },
  'heat-calculator': {
    element: '#widgets-root',
    widgetId: 'heat-calculator',
    opzetApiUrl: 'https://inzamelkalender-test.hvcgroep.nl',
    websiteUrl: 'https://staging.hvcgroep.nl',
    apiUrl: 'https://staging.app.hvcgroep.nl',
    env: 'development',
    heatCalculatorOptions: {
      costsRetention: '529.01',
      costsMeasurements: '31.68',
      costsRent: '105.91',
      costsGj: '44.36',
      minGasConsumption: '0',
      maxGasConsumption: '5000',
      defaultGasConsumption: '950',
      minGasPrice: '0.9',
      maxGasPrice: '4',
      defaultGasPrice: '1.42',
      minGasGridManagementCost: '145',
      maxGasGridManagementCost: '285',
      defaultGasGridManagementCost: '210',
      minGasFixedCost: '40',
      maxGasFixedCost: '100',
      defaultGasFixedCost: '70',
      minCvInstallationCost: '100',
      maxCvInstallationCost: '200',
      defaultCvInstallationCost: '112',
      minCvMaintenanceCost: '0',
      maxCvMaintenanceCost: '400',
      defaultCvMaintenanceCost: '168',
      priceCapEnabled: '0',
      priceCapGas: '',
      priceCapGasRange: '',
      priceCapHeat: '',
      priceCapHeatRange: '',
    },
  },
  'registration-desk': {
    element: '#widgets-root',
    widgetId: 'registration-desk',
    opzetApiUrl: 'https://inzamelkalender-test.hvcgroep.nl',
    websiteUrl: 'https://staging.hvcgroep.nl',
    apiUrl: 'https://staging.app.hvcgroep.nl',
    env: 'development',
    enableHashRouter: true,
    registrationDeskOptions: {
      minSjvGj: 5,
      maxSjvGj: 150,
      minSjvM3: 150,
      maxSjvM3: 5000,
      thanksUrl: 'https://staging.hvcgroep.nl/gelukt-wat-gaat-er-nu-gebeuren',
      termsAndConditions:
        '<ul>\r\n\t<li><a href="https://staging.hvcgroep.nl/sites/default/files/2020-02/kwaliteitscriteria.pdf" target="_blank">Kwaliteitscriteria</a></li>\r\n\t<li><a href="https://staging.hvcgroep.nl/sites/default/files/2020-01/warmte%20-%20algemene_leveringsvoorwaarden%20100%20kWth.pdf" target="_blank">Algemene leveringsvoorwaarden warmte</a></li>\r\n\t<li><a href="https://staging.hvcgroep.nl/sites/default/files/2020-01/warmte_-_%20aansluitvoorwaarden%20oktober%202018%20TOEGANKELIJK.pdf" target="_blank">Aansluitvoorwaarden warmte</a></li>\r\n\t<li><a href="https://staging.hvcgroep.nl/sites/default/files/2023-01/101-addendum_aansluitvoorwaarden_warmte_oktober_2018-0820.pdf" target="_blank">Addendum aansluitvoorwaarden warmte</a></li>\r\n\t<li><a href="https://staging.hvcgroep.nl/sites/default/files/2019-10/elektricititeit_gas_en_warmte_-_contractvoorwaarden.pdf" target="_blank">Contractvoorwaarden</a></li>\r\n</ul>\r\n',
    },
  },
};

export default defaultOptions;
